import { Button, Modal, Row, Form, Col } from 'antd'
import useFetchSelect from 'elements/Hooks/useFetchSelect'
import useModalShow from 'elements/Hooks/useModalShow'
import useSelectionTable from 'elements/Hooks/useSelectionTable'
import CustomTable from 'elements/Table/CustomTable'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, rules } from 'modules/FormItems'
import { dateVal } from 'modules/Utils'
import React, { useEffect, useState } from 'react'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'

const CheckboxTable = checkboxHOC(CustomTable)

export function VoucherMultiOrders({ vendor, company, voucher, getFieldDecorator, setFieldsValue }) {
  const { SelectData: PurchaseOrderSelect, data, fetch, fetching } = useFetchSelect({
    url: `orders?select=_id,code,title,status,taxType,tax,paymentStatus&vendor=${vendor}&company=${company}&billable=true&paid=false`,
    dependencyArray: [vendor, company],
    dontFetch: isEmpty(vendor),
    mapFunction: (o) => ({ ...o, display: `${o.code} - ${o.title}` }),
  })

  const [orders, setOrders] = useState(voucher?.orders || [])

  useEffect(() => {
    if (orders.length === 0) {
      setOrders(voucher?.orders || [])
    }
  }, [voucher])

  return (
    <div>
      <OrderModal {...{ data, setOrders, fetch, fetching, checkedList: orders, voucher }} />
      {[...Array(orders.length).keys()].map((i) => (
        <OrderPayPlanSelect
          {...{
            i,
            order: data.find((j) => j._id === (orders[i]?._id || orders[i])),
            payplan: voucher?.paymentPlans?.[i],
            PurchaseOrderSelect,
            getFieldDecorator,
            setFieldsValue,
            voucher,
          }}
        />
      ))}
    </div>
  )
}

export function OrderPayPlanSelect({
  i,
  order,
  PurchaseOrderSelect,
  getFieldDecorator,
  payplan,
  setFieldsValue,
  voucher,
}) {
  const { SelectData: PayPlanSelect, data } = useFetchSelect({
    url: `/statements/order/payplan?orders=${order?._id}`,
    dependencyArray: [order],
    // dontFetch: !!order?._id,
    mapFunction: (c) => ({
      ...c,
      display: `${c.name} ${c.date && dateVal(c, 'date').format('DD-MMM-YY')} ${c.amount} ${c.currency}`,
    }),
  })

  useEffect(() => {
    if (data.length === 1 && !payplan?._id) {
      setFieldsValue({ [`paymentPlans.${i}._id`]: data[0]._id })
    }
  }, [data])

  return (
    <Row>
      <Col span={12}>
        {voucher?.status === 'Approved' ? (
          <Form.Item {...defaultFormItemLayout} label={`Order ${i + 1}`}>
            <span>{order?.display || JSON.stringify(order)}</span>
          </Form.Item>
        ) : (
          <Form.Item {...defaultFormItemLayout} label={`Order ${i + 1}`}>
            {getFieldDecorator(`orders.${i}._id`, {
              initialValue: order?._id,
            })(
              <PurchaseOrderSelect keyAtr={'_id'} disabled valueAtr={'display'} placeholder="Select a Purchase Order" />
            )}
          </Form.Item>
        )}
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Pay Plan Schedule">
          {getFieldDecorator(`paymentPlans.${i}._id`, {
            initialValue: payplan?._id,
            rules: [{ required: true, message: 'Need To Select PayPlan!' }],
          })(
            <PayPlanSelect
              keyAtr={'_id'}
              valueAtr={'display'}
              placeholder="Select a Payment Plan"
              style={{ width: '100%' }}
            />
          )}
        </Form.Item>
      </Col>
    </Row>
  )
}

export function OrderModal({ setOrders, data, fetching, fetch, checkedList, voucher }) {
  const { visible, onShow, onCancel } = useModalShow()

  const { tableRef, selection, selectAll, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  useEffect(() => {
    if (selection.length === 0 && checkedList.length > 0) {
      checkedList.map((i) => toggleSelection(i))
    }
  }, [checkedList])

  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }
  return (
    <div>
      <Button type="primary" disabled={fetching || voucher?.status === 'Approved'} onClick={onShow}>
        Select Orders
      </Button>
      <Modal
        title="Select Order"
        onCancel={onCancel}
        destroyOnClose
        width={'90%'}
        visible={visible}
        onOk={() => {
          setOrders(selection)
          onCancel()
        }}>
        <CheckboxTable
          {...checkboxProps}
          withRef={tableRef}
          data={data?.filter((i) => i.paymentStatus !== 'Registered') || []}
          defaultPageSize={20}
          isFilterable={true}
          fetching={fetching}
          fetch={fetch}
          columns={[
            { Header: 'id', accessor: '_id' },
            { Header: 'code', accessor: 'code', width: 150 },
            { Header: 'display', accessor: 'display' },
          ]}
        />
      </Modal>
    </div>
  )
}

/// list (display)

/// modal to add/edit

// Order -> payplan (if one select)
